export default "__VITE_ASSET__VQcN8EDs__"